module.exports = __webpack_public_path__ + "img/abstract.7d8e93b.svg";